export let optionTitle_readingPane = "yqHYDd";
export let optionTitle_readingPaneLayout = "mHRpXb";
export let optionSearch_readingPane = "O$EVRd";
export let options_readingPane_right = "s9G0_";
export let options_readingPane_bottom = "nFzlje";
export let options_readingPane_classic = "_lXZoe";
export let options_readingPane_popout = "NJsoQb";
export let options_readingPane_win32Right = "bIamDc";
export let options_readingPane_win32Bottom = "u5gjMd";
export let options_readingPane_win32Off = "K6Shmc";
export let options_readingPane_resize = "yS4H6b";
export default {optionTitle_readingPane,optionTitle_readingPaneLayout,optionSearch_readingPane,options_readingPane_right,options_readingPane_bottom,options_readingPane_classic,options_readingPane_popout,options_readingPane_win32Right,options_readingPane_win32Bottom,options_readingPane_win32Off,options_readingPane_resize};